import React from 'react';
import AcceptanceColumn from './AcceptanceColumn';
import { useBookingContext } from '../context';
import moment from 'moment';

export default () => {
  const { selectedDate, startTime, endTime, price, court, setIsOpenModal } = useBookingContext();
  const disabled = !endTime;
  return (
    <>
      <div className="backdrop-blur-sm fixed bottom-0 w-full bg-[#1F1F1FCC]  md:h-[6rem] flex flex-row items-center px-1 sm:px-6">
        {!startTime ? (
          <div className="flex flex-row items-center px-4">
            <img src={'https://padel-uzh-module.web.app/assets/finger-booking.svg'} alt="" />
            <div className="text-[#C4D600] text-[16px] text-start sm:text-center sm:text-[24px] p-2 sm:pl-8">
              Оберіть час коли плануєте почати та закінчити гру
            </div>
          </div>
        ) : (
          <div className="flex flex-col md:flex-row sm:items-center items-center sm:justify-between w-full px-4 sm:px-0">
            <div className="flex flex-row items-center py-2 sm:py-0 sm:p-2">
              <AcceptanceColumn title="Дата" value={moment(selectedDate).format('DD/MM/YY')} />
              <AcceptanceColumn title="Корт" value={court?.courtName || 'N/A'} center mx />
              <AcceptanceColumn title="Початок" value={startTime || 'N/A'} center />
              <div className="border-b-2 sm:border-b-4 w-[0.7rem] sm:w-[2rem] sm:mr-6 mx-1" />
              <AcceptanceColumn
                title="Кінець гри"
                value={endTime || 'Оберіть час'}
                textColor={endTime ? 'text-white' : 'text-[#C2E403]'}
                center={endTime ? true : false}
              />
              {price ? (
                <>
                  <img
                    className="mx-4 sm:ml-0 sm:mr-6"
                    src={'https://padel-uzh-module.web.app/assets/checkout.svg'}
                    alt=""
                  />
                  <AcceptanceColumn title="Ціна" value={`${price} грн`} />
                </>
              ) : null}
            </div>
            {endTime ? (
              <div
                className={`p-3 ${disabled ? 'bg-[#404040]' : 'bg-[#C2E403]'} ${
                  disabled ? 'text-[#ffffff20]' : ''
                } rounded-full max-w-96 w-full text-[16px] font-extrabold my-4 sm:mt-8 sm:my-0 md:mt-0`}
                onClick={() => {
                  !disabled && setIsOpenModal(true);
                }}>
                Забронювати корт
              </div>
            ) : null}
          </div>
        )}
      </div>
    </>
  );
};
